/**
 * Corner-radius scale. Pure value (no React/RN imports).
 * `full` (9999) yields a pill/circle for any smaller element.
 */
export const RADIUS = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  full: 9999,
} as const;
